
import SetColor from '../setColor/index.jsx'
import SlideBar1 from '../slideBar1/index.jsx'
import Selector from '../selector/index.jsx'
import './side.less'
import React from 'react'
console.log(React)
export default function ConversionOfficialSide(props) {
  return (<div className={`conversionOfficialSide ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>
    <div className='conversionOfficialSide_no1'>
      <h3 className='title'>转化按钮：关注公众号</h3>
      <span className='tips'>用户点击按钮后，跳转公众号详情页。</span>
    </div>
    <div className='conversionOfficialSide_no2'>
      <h3 className='no2_title'>适用推广目标：推广我的公众号</h3>
      <span className='no2_text'>创建广告时，仅选择了以上推广目标的广告可使用此推广页。</span>
    </div>

    <div className='conversionOfficialSide_no3'>
      <h3 className='no3_title'>已关联公众号</h3>
      <span className='no3_text'>...</span>
    </div>

    { false && <div className='conversionOfficialSide_no7'>
      <h3 className='no7_title'>链接</h3>
      <div className='no7_item'>
        <div className='itemBox'>
          <Selector options={[{ id: 0, text: 'http://' }, { id: 1, text: 'https://' }]} activeId={props.ifon.protocolType} change={(item) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              protocolType: item.id
            })
          }}></Selector>
          <input className='item_input' placeholder='请输入链接' onChange={(e) => {
            const text = e.target.value
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              url: text
            })
          }}/>
        </div>
        <span className='tips'>链接如: www.baidu.com </span>
      </div>
    </div>}

    <div className='conversionOfficialSide_no4'>
      <button className={`switch ${props.ifon.isFollow ? 'active' : ''}`} onClick={() => {
        props.mySetIfon && props.mySetIfon({
          ...props.ifon,
          isFollow: !props.ifon.isFollow
        })
      }}>
        <i className={`switch_icon`}></i>
      </button>
      <h3 className='no4_title'>一键关注</h3>
    </div>

    <div className='conversionOfficialSide_no5'>
      <h3 className='no5_title'>按钮外观</h3>
      <div className='no5_main'>
        <div className='main_item'>
          <span className='item_title'>按钮文本</span>
          <div className='item_ifon'>
            <input className='ifon_input' value={props.ifon.title} onChange={(e) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                title: e.target.value
              })
            }} />
            <div className='ifon_button'>
              <button className={`button ${props.ifon.text_alignment === 0 ? 'active' : ''}`} onClick={() => {
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  text_alignment: 0
                })
              }}>常规</button>
              <button className={`button ${props.ifon.text_alignment === 1 ? 'active' : ''}`} onClick={() => {
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  text_alignment: 1
                })
              }}>加粗</button>
            </div>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>字体色</span>
          <div className='item_ifon'>
            <SetColor color={props.ifon.font_color} setColor={(colorObj) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                font_color: colorObj.hex
              })
            }}></SetColor>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>图标</span>
          <div className='item_ifon'>
            <button className={`switch ${props.ifon.isIcon ? 'active' : ''}`} onClick={() => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                isIcon: !props.ifon.isIcon
              })
            }}>
              <i className='switch_icon'></i>
            </button>

            <h3 className='title1'>未启用</h3>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>边框色</span>
          <div className='item_ifon'>
            <SetColor color={props.ifon.border_color} setColor={(colorObj) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                border_color: colorObj.hex
              })
            }}></SetColor>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>填充色</span>
          <div className='item_ifon'>
            <SetColor color={props.ifon.bg_color} setColor={(colorObj) => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                bg_color: colorObj.hex
              })
            }}></SetColor>
          </div>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_no6'>
      <h3 className='no6_title'>边距</h3>
      <div className='no6_main'>
        <div className='main_item'>
          <SlideBar1 title='上边距' value={props.ifon.padding_top} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_top: value
            })
          }}></SlideBar1>
        </div>
        <div className='main_item'>
          <SlideBar1 title='下边距' value={props.ifon.padding_bottom} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_bottom: value
            })
          }}></SlideBar1>
        </div>
      </div>
    </div>
  </div>)
}
